import { render, staticRenderFns } from "./cdk.vue?vue&type=template&id=6a06476a&scoped=true"
import script from "./cdk.vue?vue&type=script&lang=js"
export * from "./cdk.vue?vue&type=script&lang=js"
import style0 from "./cdk.vue?vue&type=style&index=0&id=6a06476a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a06476a",
  null
  
)

export default component.exports